import $ from 'jquery';
import { load as loadRecaptcha} from 'recaptcha-v3'

import { lockScreen, log, navigate } from 'Utils';

const RECAPTCHA_KEY = "6Lc42e4UAAAAAHnl2FUkIHPAw6GC1wxysqpPKlV5";

function renderPasswordScore(result) {
	const {score, feedback} = result;
	const {warning, suggestions} = feedback;
	/*
	Zie https://github.com/dropbox/zxcvbn#usage
		result.score      # Integer from 0-4 (useful for implementing a strength bar)
		0 # too guessable: risky password. (guesses < 10^3)
		1 # very guessable: protection from throttled online attacks. (guesses < 10^6)
		2 # somewhat guessable: protection from unthrottled online attacks. (guesses < 10^8)
		3 # safely unguessable: moderate protection from offline slow-hash scenario. (guesses < 10^10)
		4 # very unguessable: strong protection from offline slow-hash scenario. (guesses >= 10^10)
	*/
	if (score < 0) {
		return null;
	}
	if (score < 3) {
		// Evt zouden we hier iets kunnen doen met de feedback: warning en suggestions ipv enkel als alert terug te geven v/d server
		/*
		const $div = $("<div>").addClass("password weak").text("Zwak wachtwoord");
		if (warning) {
			$div.append($("<div>").text(warning));
		}
		if (suggestions) {
			const $ul = $("<ul>");
			suggestions.forEach(suggestion => {
				$ul.append($("<li>").text(suggestion));
			})
			$div.append($ul);
		}
		return $div;
		*/
		return $("<div>").addClass("password weak").text("Zwak wachtwoord");
	}
	return $("<div>").addClass("password strong").text("Sterk wachtwoord");
}

function handlePasswordKeyup(e) {
	var password = e.target.value;
	var $passwordStrength = $(".passwordStrength");
	if (! password) {
		$passwordStrength.hide();
		return;
	}
	$.ajax({
		url: '/ajax.php',
		method: 'POST',
		data: { action: 'passwordStrength', password: password }
	}).done(function(result) {
		if (! result) {
			$passwordStrength.hide();
			return;
		}
		if (result.password === password) {
			var $disp = renderPasswordScore(result);
			if (! $disp) {
				return;
			}
			$passwordStrength.empty().append($disp).show();
		}
	});
}

async function sendFormRecaptcha(e) {
	e.preventDefault();

	const form = e.target;
	try {
		const grecaptcha = await loadRecaptcha(RECAPTCHA_KEY);
		const token = await grecaptcha.execute('inschrijven');
		form.recaptcha_token.value = token;
	} catch (e) {
		log(e);
	}

	sendForm(form);
}

function sendForm(form) {
	if (! $("#algemene_voorwaarden").is(":checked")) {
		$("#algemene_voorwaarden_accept").show();
		return false;
	}

	var lock = lockScreen();
	$.ajax({
		url : '/ajax.php',
		method : 'POST',
		data : new FormData(form),
		processData: false,
		contentType: false,
	}).always(function() {
		lock.close();
	}).fail(function(jqXHR, textStatus, errorThrown) {
		var json = jqXHR.responseJSON;
		if (json && json.error) {
			alert(json.error);
			if (json.formField) {
				$(":input[name='" + json.formField + "']", form).focus();
			}
		} else {
			alert(textStatus + ": " + errorThrown);
		}
	}).done(function(obj) {
		window.dataLayer = window.dataLayer || [];
		window.dataLayer.push({'event':'subscribe-success'});

		if (obj.get_pixels) {
			obj.get_pixels.forEach(pixel => {
				const $img = $("<img>");
				$img.attr("src", pixel);
				$img.css({width:'1px',height:'1px'});
				$("body").append($img);
			});
		}

		const d = new Promise((resolve) => {
			if (typeof(window.ga) === 'undefined') {
				resolve('no_ga');
				return;
			}

			window.ga('send', {
				hitType: 'event',
				eventCategory: 'Proefaanvraag succes',
				eventAction: "Proefaanvraag succes",
				eventLabel: obj.user.id,
				hitCallback: () => resolve('success'),
			});

			setTimeout(() => {
				resolve('ga_timeout');
			}, 5000);
		});

		d.then((gaResult) => {
			$.ajax({
				url : '/ajax.php',
				method : 'POST',
				data : {
					action: 'markGoogleAnalyticsResult',
					username: obj.user.username,
					result: gaResult
				}
			}).always(() => navigate(obj.redirect)());
		}, err => log(err));
	});
	return false;
}

export function initInschrijvenPage() {
	$("#voorwaarden").on("click", function(e) {
		e.preventDefault();
		$.get($(this).attr("href")).done(function(obj) {
			var $html = $(obj);
			var str = $(".voorwaarden_en_verwerkersovereenkomst", $html).prop("outerHTML");
			$.fancybox.open({
				src : "<div class='voorwaarden-dialog'>" + str + "</div>",
				type : 'html'
			});
		});
	});

	$("#algemene_voorwaarden").on("click", function() {
		$("#algemene_voorwaarden_accept").hide();
	});

	$("[name='password_new']").on("keyup", handlePasswordKeyup);

	$("form#inschrijven").on("submit", sendFormRecaptcha);
}
